import {gql} from 'apollo-boost';

export const GET_TEACHERS = gql`
  query {
    getTeachers{
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      availableTime
      telephone
      email
      picturePath
      socialMedia
      isSpecialTeacher
      isActive
      curriculum{
        id
        currId
        code
        nameLocal
        nameEng
      }
      faculty{
        id
        code
        nameLocal
        nameEng
      }
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
      label
    }
  }
`;

export const GET_TEACHERS_DDL = gql`
  query {
    getTeachers{
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      availableTime
      telephone
      email
      picturePath
      socialMedia
      isSpecialTeacher
      isActive
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      label
    }
  }
`;

export const GET_TEACHERS_BY_FILTER = gql`
  query getTeachersByFilter($teacherFilterInput: TeacherFilterInput){
    getTeachersByFilter(
      teacherFilterInput : $teacherFilterInput
    ){
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      availableTime
      telephone
      email
      picturePath
      socialMedia
      isSpecialTeacher
      isActive
      curriculum{
        id
        currId
        code
        nameLocal
        nameEng
      }
      faculty{
        id
        code
        nameLocal
        nameEng
      }
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      label
    }
  }
`;

export const GET_TEACHER = gql`
  query getTeacher($id : ID!){
    getTeacher (
      id: $id
    ) {
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      availableTime
      telephone
      email
      picturePath
      socialMedia
      isSpecialTeacher
      isActive
      curriculum{
        id
        currId
        code
        nameLocal
        nameEng
      }
      faculty{
        id
        code
        nameLocal
        nameEng
      }
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
    }
  }
`;

export const ADD_TEACHER = gql`
  mutation addTeacher(
    $teacherInput: TeacherInput!,
    $curriculumId: ID!,
    $facultyId: ID!,
    $prefixId: ID!,
    $userId: ID,
  ) {
    addTeacher(
      teacherInput: $teacherInput
      curriculumId: $curriculumId
      facultyId: $facultyId
      prefixId: $prefixId
      userId: $userId
    ) {
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      availableTime
      telephone
      email
      picturePath
      socialMedia
      isSpecialTeacher
      isActive
      curriculum{
        id
        currId
        code
        nameLocal
        nameEng
      }
      faculty{
        id
        code
        nameLocal
        nameEng
      }
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
    }
  }
`;

export const ADD_TEACHERS_UPLOAD = gql`
  mutation addTeachersUpload(
    $teachersUploadInput: [TeachersUploadInput]
  ) {
    addTeachersUpload (
      teachersUploadInput: $teachersUploadInput,
    )
    {
      successCount
      failCount
      resultAddTeacherUpload{
        no curriculumCode facultyCode prefixCode code firstNameLocal lastNameLocal firstNameEng lastNameEng
        availableTime telephone email socialMedia isSpecialTeacher status remark
      }

    }
  }
`;

export const UPDATE_TEACHER = gql`
  mutation updateTeacher(
    $id: ID!,
    $teacherInput: TeacherInput!,
    $curriculumId: ID,
    $facultyId: ID,
    $prefixId: ID!,
    $userId: ID,
  ) {
    updateTeacher(
      id: $id
      teacherInput: $teacherInput
      curriculumId: $curriculumId
      facultyId: $facultyId
      prefixId: $prefixId
      userId: $userId
    ) {
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      availableTime
      telephone
      email
      picturePath
      socialMedia
      isSpecialTeacher
      isActive
      curriculum{
        id
        currId
        code
        nameLocal
        nameEng
      }
      faculty{
        id
        code
        nameLocal
        nameEng
      }
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
    }
  }
`;

export const DELETE_TEACHER = gql`
  mutation deleteTeacher($id: ID!) {
    deleteTeacher(
      id: $id
    ) {
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      availableTime
      telephone
      email
      picturePath
      socialMedia
      isSpecialTeacher
      isActive
      curriculum{
        id
        currId
        code
        nameLocal
        nameEng
      }
      faculty{
        id
        code
        nameLocal
        nameEng
      }
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
    }
  }
`;

